module.exports = __webpack_public_path__ + "img/u752.5096df3d.png";